<div class="app-page">
  <mat-toolbar>
    <a mat-icon-button [routerLink]="['/search']" aria-label="Back to search menu">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </a>
    <span>{{ 'SEARCH.REPORT_SEARCH' | translate }}</span>
  </mat-toolbar>
  <div class="app-page" style="margin-left: 5px;">
    <form [formGroup]="searchForm">

      <div class="search-form-toolbar">
        <button mat-stroked-button type="button" (click)="toggleSearchForm()">
          <mat-icon>{{ isSearchFormCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
          {{ (isSearchFormCollapsed ? 'SEARCH.SHOW_SEARCH_FIELDS' : 'SEARCH.HIDE_SEARCH_FIELDS') | translate }}
        </button>        <a mat-raised-button color="primary" (click)="this.searchReports()">{{ 'SEARCH.SEARCH' | translate }}</a>
      </div>

      @if (!isSearchFormCollapsed) {

      <mat-form-field appearance="fill"  style="font-size: small;" >
        <mat-label>{{ 'GENERAL.LASTNAME' | translate }}</mat-label>
        <input matInput formControlName="PlayerLastName" placeholder="{{ 'GENERAL.LASTNAME' | translate }}" required>
        <mat-hint>{{ 'SEARCH.USE_WILDCARD' | translate }}</mat-hint>
      </mat-form-field>&nbsp;
      <mat-form-field  appearance="fill"  style="font-size: small;">
        <mat-label>{{ 'GENERAL.FIRSTNAME' | translate }}</mat-label>
        <input matInput formControlName="PlayerFirstName" placeholder="{{ 'GENERAL.FIRSTNAME' | translate }}" >
        <mat-hint>{{ 'SEARCH.USE_WILDCARD' | translate }}</mat-hint>
      </mat-form-field>&nbsp;
      <mat-form-field  appearance="fill"  style="font-size: small;">
        <mat-label>{{ 'PLAYER.POSITION' | translate }}</mat-label>
        <mat-select formControlName="PositionIds" id="PositionIds" multiple>
          <mat-option value="1">{{ 'PLAYER.GOALTENDER' | translate }}</mat-option>
          <mat-option value="2">{{ 'PLAYER.DEFENDER' | translate }}</mat-option>
          <mat-option value="4">{{ 'PLAYER.FORWARD' | translate }}</mat-option>
          <mat-option value="5">{{ 'PLAYER.CENTER' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>&nbsp;
      <mat-form-field  appearance="fill" style="font-size: small;">
        <mat-label>{{ 'PLAYER.YEAR_OF_BIRTH' | translate }}</mat-label>
        <mat-select formControlName="YearsOfBirth" id="YearsOfBirth" multiple>
          @for (year of availableBirthYears; track year) {
            <mat-option [value]="year">{{year}}</mat-option>
          }

        </mat-select>
      </mat-form-field>&nbsp;
      <mat-form-field  appearance="fill" style="font-size: small;">
        <mat-label>{{ 'PLAYER.SHOOTS_GLOVE' | translate }}</mat-label>
        <mat-select formControlName="ShootIds" id="ShootIds" multiple>
          <mat-option value="1">{{ 'GENERAL.LEFT' | translate }}</mat-option>
          <mat-option value="2">{{ 'GENERAL.RIGHT' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>&nbsp;
      <div style="font-family: Roboto;">
        {{ 'SEARCH.REPORT_PARAMETERS' | translate }}
      </div>
      @if (reportMasterdata$ | async; as reportMasterdata) {
        <mat-form-field  appearance="fill" style="font-size: small;">
          <mat-label>Projection</mat-label>
          <mat-select formControlName="Projections" id="Projections" multiple>
            @for (proj of reportMasterdata.Projection; track proj.Ranking) {
              <mat-option [value]="proj.Ranking">
                {{ proj.Text}}@if (proj.Hidden) {
                <span style="color: gray;"> (hidden)</span>
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      &nbsp;
        <mat-form-field  appearance="fill" style="font-size: small; margin-right: 10px;">
          <mat-label>{{ 'SCOUTING.PLAYER_CAPACITY' | translate }}</mat-label>
          <mat-select formControlName="Capacities" id="Capacities" multiple>
            @for (proj of reportMasterdata.Capacity; track proj.Ranking) {
              <mat-option [value]="proj.Ranking">
                {{ proj.Text}}
                @if (proj.Hidden) {
                  <span style="color: gray;"> (hidden)</span>
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
     
      
      <mat-form-field appearance="fill" style="font-size: small;" >
        <mat-label >{{ 'SEARCH.REPORT_DATE_FROM' | translate }}</mat-label>
        <input matInput [matDatepicker]="pickerfrom" formControlName="minReportDate"   name="minReportDate">
        <mat-datepicker-toggle matSuffix [for]="pickerfrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerfrom></mat-datepicker>
      </mat-form-field>
      &nbsp;
      <mat-form-field appearance="fill" style="font-size: small;">
        <mat-label >{{ 'SEARCH.REPORT_DATE_TO' | translate }}</mat-label>
        <input matInput [matDatepicker]="pickerto" formControlName="maxReportDate"   name="maxReportDate">
        <mat-datepicker-toggle matSuffix [for]="pickerto"></mat-datepicker-toggle>
        <mat-datepicker #pickerto></mat-datepicker>
      </mat-form-field>&nbsp;


        <mat-form-field  appearance="fill" style="font-size: small;">
          <mat-label>{{ 'SEARCH.MAX_NO_OF_ROWS' | translate }}</mat-label>
          <mat-select formControlName="MaxHits" id="MaxHits" >
            <mat-option selected value="50">50</mat-option>
            <mat-option value="100">100</mat-option>
            <mat-option value="200">200</mat-option>
            <mat-option value="500">500</mat-option>

          </mat-select>
        </mat-form-field>
      }
      </form>
      <br/>
      @if (this.isBusy) {
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
        ></mat-progress-spinner>
      }
      <table class="report-results-table" mat-table [dataSource]="dataSource" matSort style="margin-left: 0; width: 100%;" >

        <ng-container matColumnDef="Player">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"GENERAL.PLAYER" | translate}} </th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.PlayerLastName}}, {{element.PlayerFirstName}}  </td>

        </ng-container>
        <ng-container matColumnDef="PlayerFirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"PLAYER.FIRSTNAME" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.PlayerFirstName}} </td>

        </ng-container>
        <ng-container matColumnDef="DateOfBirth">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"PLAYER.DATE_OF_BIRTH" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.DateOfBirth | date:'yyy-MM-dd'}} </td>

        </ng-container>
        <ng-container matColumnDef="DateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"SCOUTING.REPORT_DATE" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.DateCreated | date:'yyy-MM-dd'}} </td>

        </ng-container>
        <ng-container matColumnDef="Weight">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"PLAYER.WEIGHT" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.Weight}} </td>

        </ng-container>
        <ng-container matColumnDef="Height">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"PLAYER.HEIGHT" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.Height}} </td>

        </ng-container>
        <ng-container matColumnDef="TotalQualityText">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"SCOUTING.PROJECTION" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.TotalQualityText}} </td>

        </ng-container>
        <ng-container matColumnDef="PlayerCapacityText">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"SCOUTING.PLAYER_CAPACITY" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.PlayerCapacityText}} </td>

        </ng-container>
        <ng-container matColumnDef="CreatedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"SCOUTING.CREATED_BY" | translate}}</th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;" > {{element.CreatedByLastName}}, {{element.CreatedByFirstName}}  </td>

        </ng-container>
        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef > {{"GENERAL.ACTIONS" | translate}} </th>
          <td mat-cell *matCellDef="let element" style="font-size: 12px;">
            <button mat-icon-button (click)="openViewReport(element.ReportId)">
              <mat-icon style="font-size: 24px; opacity: 0.6;">
                preview
              </mat-icon>

            </button>
            <button mat-icon-button style="opacity: 0.6;" (click)="openPlayer(element.PlayerId)">
              <mat-icon>
                account_box
              </mat-icon>
            </button>
            <!-- <a mat-button [routerLink]="['/scouting/playerdetails', element.PlayerId]">VIEW</a> -->
          </td>

        </ng-container>



        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 30px; font-size: 12px;;"></tr>
        <!--   <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" style="height: 24px;"></tr> -->
      </table>
      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons matSort style="margin-left: 0;"></mat-paginator>

    </div>
